// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MemosTabQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type MemosTabQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string } | null } | null> | null } };

export const Operations = {
  Query: {
    MemosTab: 'MemosTab' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const MemosTabDocument = gql`
    query MemosTab($householdId: ID!) {
  documents(where: {hasHouseholdWith: [{id: $householdId}]}, first: 1) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useMemosTabQuery__
 *
 * To run a query within a React component, call `useMemosTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemosTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemosTabQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useMemosTabQuery(baseOptions: Apollo.QueryHookOptions<MemosTabQuery, MemosTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemosTabQuery, MemosTabQueryVariables>(MemosTabDocument, withFetchPolicyContext(options));
      }
export function useMemosTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemosTabQuery, MemosTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemosTabQuery, MemosTabQueryVariables>(MemosTabDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useMemosTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemosTabQuery, MemosTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemosTabQuery, MemosTabQueryVariables>(MemosTabDocument, withFetchPolicyContext(options));
        }
export type MemosTabQueryHookResult = ReturnType<typeof useMemosTabQuery>;
export type MemosTabLazyQueryHookResult = ReturnType<typeof useMemosTabLazyQuery>;
export type MemosTabSuspenseQueryHookResult = ReturnType<typeof useMemosTabSuspenseQuery>;
export type MemosTabQueryResult = Apollo.QueryResult<MemosTabQuery, MemosTabQueryVariables>;